import api from './utilPartner';

const controller = 'SmartSearch';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  ListarPropostas: function (search) {
    return api.Axios.GetParams(`${url}/ListarPropostas`, search);
  },
});
